import type { Namespace } from '../types';

// DE drafted — queued for native review in the task file's "DE review queue".
export const settings = {
  title: { de: 'Einstellungen', en: 'Settings' },
  desc: { de: 'Konto und Präferenzen verwalten', en: 'Manage your account and preferences' },

  tabProfile: { de: 'Profil', en: 'Profile' },
  tabSecurity: { de: 'Sicherheit', en: 'Security' },
  tabNotifications: { de: 'Benachrichtigungen', en: 'Notifications' },
  tabSite: { de: 'Standort', en: 'Site' },

  toastSaved: { de: 'Profil gespeichert', en: 'Profile saved' },
  toastSaveFailed: {
    de: 'Speichern fehlgeschlagen — bitte erneut versuchen',
    en: 'Save failed — please try again',
  },
  comingSoon: { de: 'Dieser Bereich folgt in Kürze.', en: 'This section is coming soon.' },

  theme: { de: 'Design', en: 'Theme' },
  themeLight: { de: 'Hell', en: 'Light' },
  themeDark: { de: 'Dunkel', en: 'Dark' },
  themeSystem: { de: 'System', en: 'System' },
  fontSize: { de: 'Schriftgröße', en: 'Font size' },
  fontSmall: { de: 'Klein', en: 'Small' },
  fontDefault: { de: 'Standard', en: 'Default' },
  fontLarge: { de: 'Groß', en: 'Large' },
} as const satisfies Namespace;
